import UIPanelBody from 'UIComponents/panel/UIPanelBody';
import { useEffect, useState } from 'react';
import ObjectNameReference from 'automation-ui-enrollment/components/filters/enrollment/generic-enrollment-table/ObjectNameReference';
import UIBackButton from 'UIComponents/nav/UIBackButton';
import UILink from 'UIComponents/link/UILink';
import { atomicQueryUpdate } from 'automation-ui-routing/historyUtils';
import { useHistory } from 'react-router-dom';
import { RECORD_ID_QUERY_PARAM } from 'automation-ui-canvas/containers/flow-views/test-flow/constants';
import SimulationStartSection from 'automation-ui-canvas/containers/flow-views/test-flow/SimulationStartSection';
import SimulationActionsSection from 'automation-ui-canvas/containers/flow-views/SimulationActionsSection';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { useTrackEvent } from 'automation-ui-usage-tracking/usageTrackingHooks';
import Trackables from 'automation-ui-usage-tracking/Trackables';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TestFlowViewSimulatePanel = ({
  flow,
  recordId,
  viewData,
  onCancel
}) => {
  var _historyEvents$;
  const history = useHistory();
  const [enrollType, setEnrollType] = useState(flow.isEnabled ? 'MANUAL' : 'DYNAMIC');
  const {
    simulateFlow,
    historyEvents,
    simulateEnrollment
  } = viewData;
  const trackEvent = useTrackEvent();
  useEffect(() => {
    trackEvent(Trackables.SIMULATE_RECORD, {
      subscreen: enrollType
    });
  }, [trackEvent, enrollType]);
  useEffect(() => {
    simulateFlow({
      flowId: flow.flowId,
      objectId: recordId,
      enrollType,
      sendEmailsToUser: false
    });
    simulateEnrollment({
      flowId: flow.flowId,
      objectId: recordId,
      enrollType
    });
  }, [flow, simulateFlow, simulateEnrollment, recordId, enrollType]);
  return /*#__PURE__*/_jsxs(UIPanelBody, {
    children: [/*#__PURE__*/_jsxs(TFlex, {
      backgroundColor: "fill-surface-raised",
      paddingInline: "500",
      paddingBlockStart: "500",
      paddingBlockEnd: "300",
      direction: "column",
      children: [/*#__PURE__*/_jsx(UIBackButton, {
        children: /*#__PURE__*/_jsx(UILink, {
          onClick: () => {
            atomicQueryUpdate({}, [RECORD_ID_QUERY_PARAM], history);
          },
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation.testV2.simulatePanel.changeRecord"
          })
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "m-x-4 m-y-3",
        children: /*#__PURE__*/_jsx(ObjectNameReference, {
          objectTypeId: flow.objectTypeId,
          id: recordId
        })
      })]
    }), /*#__PURE__*/_jsx(SimulationStartSection, {
      enrollType: enrollType,
      setEnrollType: setEnrollType,
      viewData: viewData,
      flow: flow,
      timestamp: historyEvents === null || historyEvents === void 0 || (_historyEvents$ = historyEvents[0]) === null || _historyEvents$ === void 0 ? void 0 : _historyEvents$.timestamp,
      onCancel: onCancel
    }), /*#__PURE__*/_jsx(SimulationActionsSection, {
      flow: flow,
      historyEvents: historyEvents,
      recordId: recordId,
      viewData: viewData
    })]
  });
};
export default TestFlowViewSimulatePanel;